import { handleMessages, load } from './util';

const api = {
  addPosition($this, store, options = null) {
    const $form = $this.closest('form');
    const isReel = $form.attr('data-reels');
    const hasContracts = $form.attr('data-contracts');

    if (isReel || hasContracts) {
      const $qty = $form.find('input[name="quantity"]');
      const data = {};
      if ($qty && $qty.val() !== '') {
        data.quantity = $qty.val();
      }
      return $.ajax({
        method: 'GET',
        url: isReel || hasContracts,
        data,
      }).done((resp) => {
        const element = $(resp).appendTo($('body'));
        element.foundation().foundation('open');
      });
    }

    const data = $form.serializeArray();
    if ($(`[data-bind-html="${store}:html"]`).length) {
      data.push({ name: 'render', value: 1 });
      data.push({ name: 'calculate', value: 1 });
    }

    let action = $form.attr('action');
    if (options) {
      const idx = action.indexOf('?');
      const host = idx >= 0 ? action.substr(0, idx) : action;
      const params = new URLSearchParams(idx >= 0 ? action.substr(idx) : '');
      $.each(options, (k, v) => {
        params.set(k, v);
      });
      action = `${host}?${params.toString()}`;
    }

    return load(
      $this,
      $.stores[store].post(action, data),
    );
  },

  copyPositions($this, store) {
    const $form = $this.closest('form');
    const data = $form.serializeArray();

    load(
      this,
      $.stores[store].post($form.attr('action'), data),
    );
  },

  addPositionDiversItem($this, store) {
    const $form = $this.closest('form');
    const data = $form.serializeArray();

    load(
      $this,
      $.stores[store].post($form.attr('action'), data),
    ).then(() => {
      if ($this.is('[data-reveal]')) {
        setTimeout(() => $this.foundation('close'), 1500);
      }
    });
    $this.get(0).reset();
  },

  addConfigurationItem($actionForm, $form, store) {
    const data = $form.serializeArray();
    load(
      $actionForm,
      $.stores[store].post($actionForm.attr('action'), data),
    );
  },

  updateQuantity($this, store, force = false) {
    if (force || $this.val() !== $this.get(0).defaultValue) {
      const $form = $this.closest('form');
      const data = $form.serializeArray();
      if ($(`[data-bind-html="${store}:html"]`).length) {
        data.push({ name: 'render', value: 1 });
        data.push({ name: 'calculate', value: 1 });
      }
      $this.get(0).defaultValue = $this.val();
      load(
        $form,
        $.stores[store].post($form.attr('action'), data).then((response) => {
          $this.val(parseFloat(response.position.quantity));
        }),
        { errorClass: 'error' },
      );
    }
  },

  setPositionText($this, store) {
    const data = $this.serializeArray();
    load(
      $this,
      $.stores[store].post($this.attr('action'), data),
      { errorClass: 'error' },
    );
  },

  removePosition($this, store) {
    const $form = $this.closest('form');
    const data = $form.serializeArray();
    load(
      $this,
      $.stores[store].post($form.attr('action'), data),
    );
  },

  clear($this, store) {
    const $form = $this.closest('form');
    const data = $form.serializeArray();
    load(
      $this,
      $.stores[store].post($form.attr('action'), data),
    );
  },

  importPositions($this, store) {
    const $form = $this.removeClass('error');
    const $msg = $form.find(`[data-${store}-import-messages]`).html('').hide().removeClass('alert');
    const $data = $form.find('[data-container-import-data]');
    const data = new FormData($form[0]);
    load(
      $this,
      $.stores[store].post($form.attr('action'), data),
    ).then((result) => {
      if (result.has_errors === true) {
        $form.addClass('error');
        $msg.addClass('alert');
        if ($data.length && result.errors) {
          $data.val(result.errors);
        }
      } else if ($data.length) {
        $data.val('');
      }
      $msg.html(result.import_messages)[result.import_messages ? 'show' : 'hide']();
    });
  },

  changePositionReel($this, store) {
    const $position = $this.closest(`[data-${store}-item]`);
    const positionId = $this.attr(`data-change-${store}-position-reel`);
    const qty = $position.find(`[data-update-${store}-position-quantity]`).val();

    $.ajax({
      method: 'GET',
      url: $this.attr('href'),
      data: {
        quantity: qty,
        position: positionId,
        app: store,
      },
    }).done((resp) => {
      const element = $(resp).appendTo($('body'));
      element.foundation().foundation('open');
    });
  },

  updatePositionReel($this, store) {
    const data = $this.serializeArray();
    load(
      $this,
      $.stores[store].post($this.attr('action'), data),
      { errorClass: 'error' },
    ).then(() => {
      const $reveal = $this.closest('[data-reveal]');
      if ($reveal) {
        $reveal.foundation('close');
      }
    });
  },

  setObject($this, store) {
    const data = new FormData();
    data.append('csrfmiddlewaretoken', $('meta[name="csrf-token"]').attr('content'));
    if ($(`[data-bind-html="${store}:html"]`).length) {
      data.append('render', 1);
      data.append('calculate', 1);
    }
    load(
      $this,
      $.stores[store].post($this.attr('data-object-set'), data),
    ).then(() => {
      const $reveal = $this.closest('[data-reveal]');
      if ($reveal) {
        $reveal.foundation('close');
      }
    });
  },

  resetObject($this, store) {
    const data = new FormData();
    data.append('csrfmiddlewaretoken', $('meta[name="csrf-token"]').attr('content'));
    if ($(`[data-bind-html="${store}:html"]`).length) {
      data.append('render', 1);
      data.append('calculate', 1);
    }
    load(
      $this,
      $.stores[store].post($this.attr('data-object-reset'), data),
    ).then(() => {
      const $reveal = $this.closest('[data-reveal]');
      if ($reveal) {
        $reveal.foundation('close');
      }
    });
  },

  showUpdateReveal($this) {
    $.ajax({
      url: $this.attr('href'),
      method: 'GET',
    }).done((resp) => {
      const element = $(resp).appendTo($('body'));
      element.foundation().foundation('open');
    });
  },

  updateContainer($this, store) {
    const $label = $this.find('[for="id_label"]').removeClass('is-invalid-label');
    $label.find('input').removeClass('is-invalid-input');
    $label.find('.form-error').remove();
    $this.addClass('loading');

    $.stores[store].setLabel(
      $this.attr('action'),
      $this.serializeArray(),
    ).then((response) => {
      if (response.status) {
        handleMessages(response);
        if (response.success_url) {
          $this.addClass('loaded');
          $this.removeClass('loading');
          document.location.href = response.success_url;
        } else {
          $this.closest('[data-reveal]').foundation('close');
        }
      } else {
        if (response.errors) {
          response.errors.forEach((error) => {
            $label.append($(`<span class="form-error is-visible">${error}</span>`));
          });
          $label.addClass('is-invalid-label');
          $label.find('input').addClass('is-invalid-input');
        }
        $this.removeClass('loading');
      }
    });
  },

  updateGroup($this, store) {
    const $label = $this.find('[for="id_label"]').removeClass('is-invalid-label');
    $label.find('input').removeClass('is-invalid-input');
    $label.find('.form-error').remove();
    $this.addClass('loading');

    $.stores[store].post(
      $this.attr('action'),
      $this.serializeArray(),
    ).then((response) => {
      if (response.status) {
        $this.closest('[data-reveal]').foundation('close');
      } else {
        if (response.errors) {
          response.errors.forEach((error) => {
            $label.append($(`<span class="form-error is-visible">${error}</span>`));
          });
          $label.addClass('is-invalid-label');
          $label.find('input').addClass('is-invalid-input');
        }
        $this.removeClass('loading');
      }
    });
  },
};

export default api;

$(document).on('click', '[data-container-group-toggle]', function() {
  const group = $(this).closest('[data-container-group]').toggleClass('is-open');
  group.find('[data-container-group-content]').toggle(100);
});

$(document).on('click', '[data-container-editmode-toggle]', function(event) {
  event.preventDefault();
  if (!$.stores[$(this).attr('data-container-editmode-toggle')].editMode) {
    $('[data-container-editmode]').find('.container-editmode__options')
      .addClass('container-editmode__options--disabled');
    $('[data-container-position-editmode]').each((idx, input) => {
      input.checked = false;
    });
    $('[data-container-position-editmode-all]').get(0).checked = false;
    $('[data-container-position-select]').text(0);
  }
  $.stores[$(this).attr('data-container-editmode-toggle')].toggleEditMode();
});

$(document).on('change', '[data-container-position-editmode]', () => {
  const countAll = $('[data-container-position-editmode]').length;
  const count = $('[data-container-position-editmode]:checked').length;
  $('[data-container-position-select]').text(count);
  $('[data-container-position-editmode-all]').get(0).checked = countAll === count;
  const func = count ? 'removeClass' : 'addClass';
  $('[data-container-editmode] .container-editmode__options')[func]('container-editmode__options--disabled');
});

$(document).on('change', '[data-container-position-editmode-all]', function() {
  const all = this;
  $('[data-container-position-editmode]').each((idx, input) => {
    input.checked = all.checked;
  });
  const count = $('[data-container-position-editmode]:checked').length;
  $('[data-container-position-select]').text(count);
  const func = count ? 'removeClass' : 'addClass';
  $('[data-container-editmode] .container-editmode__options')[func]('container-editmode__options--disabled');
});

$(document).on('click', '[data-container-editmode-close]', function(event) {
  event.preventDefault();
  $.stores[$(this).attr('data-container-editmode-close')].disableEditMode();
  const editMode = $(this).closest('[data-container-editmode]');
  editMode.find('.container-editmode__options').addClass('container-editmode__options--disabled');
  $('[data-container-position-editmode]').each((idx, input) => {
    input.checked = false;
  });
  $('[data-container-position-editmode-all]').get(0).checked = false;
  $('[data-container-position-select]').text(0);
});
